import React, { useEffect, useState } from 'react';
import { Container, Card, Form, Row, Col, Button, Table, Badge } from 'react-bootstrap';
import { apiService, Producto } from '../services/api';

const Productos: React.FC = () => {
  const [productos, setProductos] = useState<Producto[]>([]);
  const [loading, setLoading] = useState(false);
  const [filtros, setFiltros] = useState({ nombre: '', codigo_barra: '', id_categoria: '' });

  const cargar = async () => {
    setLoading(true);
    try {
      const response = await apiService.getProducts({
        nombre: filtros.nombre || undefined,
        codigo_barra: filtros.codigo_barra || undefined,
        id_categoria: filtros.id_categoria ? Number(filtros.id_categoria) : undefined,
        estado: 1,
        per_page: 50,
      });
      if (response.estado === 1 && response.registros) {
        setProductos(response.registros);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  return (
    <Container fluid>
      <Card className="shadow-sm border-0 mb-3">
        <Card.Header className="bg-primary text-white">
          <h5 className="mb-0"><i className="fas fa-box me-2"></i> Productos</h5>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={(e) => { e.preventDefault(); cargar(); }}>
            <Row className="g-2">
              <Col md={4}>
                <Form.Control placeholder="Nombre" value={filtros.nombre} onChange={(e) => setFiltros({ ...filtros, nombre: e.target.value })} />
              </Col>
              <Col md={4}>
                <Form.Control placeholder="Código de barras" value={filtros.codigo_barra} onChange={(e) => setFiltros({ ...filtros, codigo_barra: e.target.value })} />
              </Col>
              <Col md={4}>
                <div className="d-grid">
                  <Button type="submit" variant="primary" disabled={loading}>
                    <i className={`fas fa-search ${loading ? 'fa-spin' : ''} me-2`}></i>
                    Buscar
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <Card className="shadow-sm border-0">
        <Card.Header className="bg-light">
          <h6 className="mb-0">Listado ({productos.length})</h6>
        </Card.Header>
        <Card.Body>
          <Table responsive hover size="sm" className="align-middle">
            <thead className="table-light">
              <tr>
                <th>Producto</th>
                <th>Código</th>
                <th className="text-center">Stock</th>
                <th className="text-end">Precio</th>
              </tr>
            </thead>
            <tbody>
              {productos.map(p => (
                <tr key={p.id_producto}>
                  <td className="small fw-semibold text-truncate" style={{ maxWidth: 360 }}>{p.nombre_producto}</td>
                  <td className="small">{p.codigo_barra_producto}</td>
                  <td className="text-center"><Badge bg={p.inventario > 0 ? 'success' : 'danger'}>{p.inventario}</Badge></td>
                  <td className="text-end small">${p.precio_venta_producto.toLocaleString('es-CL')}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Productos;
